<template>
	<div class="medicalRecord-page">
		<time-num></time-num>
		<div class="record-content">
			<div class="content">
				<div class="content-height">
					<div class="content-box">
						<div class="topText">请查阅宠物病历记录，了解病历详情</div>
						<div class="detailed">
							<div class="detailedTop">
								<img src="./../../assets/treat/ramshorn.png" alt />
								<div class="text">宠物病情概要</div>
							</div>
							<div class="purpleText">{{ medicalrecordObj.summary }}</div>
							<div class="classification" v-for="(item, index) in medicalrecordObj.expands" :key="index">
								<span class="classification-purpleText">{{ item.label }}:</span>
								<span class="classification-blackText">{{ item.text }}</span>
							</div>
						</div>
						<div class="container-scroll" v-show="stepNum > 2">
							<div class="container-box">
								<div class="title">
									<img src="./../../assets/treat/result.png" alt />
									<p>视诊结果</p>
								</div>
								<div class="result" v-show="caseData.step2AnswerError">
									(作答有误，后续谨慎判断)
								</div>
								<div class="content-title" v-for="(v, i) in caseData.step2Items" :key="i">
									<span class="tipLabel">{{ v.label }}:</span>
									<span class="tipContent">{{ v.content }}</span>
								</div>
							</div>
							<div class="container-box" v-show="stepNum >= 3.1">
								<div class="title">
									<img src="./../../assets/treat/askZheo.png" alt />
									<p>鉴别诊断</p>
								</div>
								<div class="content-titlejb">
									该阶段作答为您的主观判断，病例记录中不做记录。
								</div>
							</div>
							<!-- <div class="container-box" v-show="stepNum > 4">
                <div class="title">
                  <img src="./../../assets/treat/inspectiono.png" alt />
                  <p>临床检查</p>
                </div>
                <div class="result" v-show="caseData.step4AnswerError">
                  (作答有误，后续谨慎判断)
                </div>
                <div
                  class="content-title"
                  v-for="(v, i) in caseData.step4Items"
                  :key="i"
                >
                  <span class="tipLabel">{{ v.label }}:</span>
                  <span class="tipContent">{{ v.content }}</span>
                </div>
              </div> -->
							<div class="container-box" v-show="stepNum > 5">
								<div class="title">
									<img src="./../../assets/treat/diagnoseo.png" alt />
									<p>最终诊断</p>
								</div>
								<div class="result" v-show="caseData.step5AnswerError">
									(作答有误，后续谨慎判断)
								</div>
								<div class="content-title" v-for="(v, i) in caseData.step5Items" :key="i">
									<span class="tipLabel">{{ v.label }}:</span>
									<span class="tipContent">{{ v.content }}</span>
								</div>
							</div>
							<div class="container-box" v-show="stepNum === 7">
								<div class="title">
									<img src="./../../assets/treat/drugo.png" alt />
									<p>确认疗法</p>
								</div>
								<div class="result" v-show="caseData.step6AnswerError">
									(作答有误)
								</div>
								<div class="content-title" v-for="(v, i) in caseData.step6Items" :key="i">
									<span class="tipLabel">{{ v.label }}:</span>
									<span class="tipContent">{{ v.content }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="glide" v-show="stepNum > 2">
					<van-icon name="arrow-down" />
				</div>
			</div>
		</div>
		<div class="medicalRecordFooter">
			<!-- <div v-if="stepNum=='1.1'" class="nextquestionactive" @click="$router.replace('/treat/pruritus')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div>
			<div v-if="stepNum=='2.1'" class="nextquestionactive" @click="$router.replace('/treat/point')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div>
			<div v-if="stepNum=='3.1'" class="nextquestionactive" @click="$router.replace('/treat/distinguish')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div>
			<div v-if="stepNum=='4.1'" class="nextquestionactive" @click="$router.replace('/treat/clinical')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div>
			<div v-if="stepNum=='5.1'" class="nextquestionactive" @click="$router.replace('/treat/final')">
				<img class="next1" src="./../../assets/home/previous.png"></img>上一步
			</div> -->
			<div @click="handleNextBtn" class="text">{{ blText }}</div>
		</div>
		<mi-xin></mi-xin>
	</div>
</template>

<script>
	import {
		getCaseRecord
	} from "@/api/system/exam";
	import {
		mapState,
		mapMutations
	} from "vuex";
	import MiXin from "../mixins/index";
	import TimeNum from "../mixins/timeNum";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		components: {
			MiXin,
			TimeNum,
		},
		data() {
			return {
				blText: "下一步",
				recordClientHeight: false,
				medicalrecordObj: {},
				stepNum: "",
				caseData: {},
				modelTimes: 1200,
				visible: false,
				visibleName: "",
				fromPath: null,
				routerNum: "",
			};
		},
		computed: {
			...mapState("visualExamination", [
				"treatmentList",
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				"treatmentEcho",
			]),
			...mapState("microscope", ["examDetailId"]),
		},
		created() {
			this.medicalrecordObj = this.treatmentList;
			this.init();
			this.stepNum = Number(this.$route.query.num);
			var str = this.stepNum + "";
			if (str.indexOf(".") == -1) {
				this.blText = "返回";
			} else {
				this.blText = "下一步";
			}
			console.log(this.detail,
				this.detailsz2,
				this.detail3,
				this.detailstepPre3,
				this.detail4,
				this.detail5, );
		},
		beforeRouteEnter(to, from, next) {
			next((vm) => {
				vm.fromPath = from.path; //获取上一级路由的路径
			});
		},
		mounted() {
			if (document.documentElement.clientHeight >= 1038) {
				this.recordClientHeight = false;
			} else {
				this.recordClientHeight = true;
			}
		},
		methods: {
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
			//关闭弹框
			handleOk() {
				this.visible = false;
			},
			//查询病例记录
			init() {
				this.stepNum = Number(this.$route.query.num);
				let data = {};
				if (
					this.stepNum === 2.1 ||
					this.stepNum === 3 ||
					this.stepNum === 3.1 ||
					this.stepNum === 4
				) {
					data = {
						paperId: this.medicalrecordObj.id,
						step2: this.detail,
					};
				} else if (this.stepNum === 4.1 || this.stepNum === 5) {
					data = {
						paperId: this.medicalrecordObj.id,
						step2: this.detail,
						step4: this.detail3,
						step4Pre: this.detailstepPre3.length === 1 ? this.detailstepPre3[0] : {},
					};
				} else if (this.stepNum === 5.1 || this.stepNum === 6) {
					data = {
						paperId: this.medicalrecordObj.id,
						step2: this.detail,
						step4: this.detail3,
						step4Pre: this.detailstepPre3.length === 1 ? this.detailstepPre3[0] : {},
						step5: this.detail4[0],
					};
				} else if (this.stepNum === 6.1 || this.stepNum === 7) {
					data = {
						paperId: this.medicalrecordObj.id,
						step2: this.detail,
						step4: this.detail3,
						step4Pre: this.detailstepPre3.length === 1 ? this.detailstepPre3[0] : {},
						step5: this.detail4[0],
						step6: this.detail5.length === 1 ? this.detail5[0] : {},
					};
				}
				if (this.stepNum >= 2.1) {
					getCaseRecord(data).then((res) => {
						this.caseData = {
							step2AnswerError: res.data.data.step2AnswerError,
							step2Items: res.data.data.step2Items,
							step4AnswerError: res.data.data.step4AnswerError,
							step4Items: res.data.data.step4Items,
							step5AnswerError: res.data.data.step5AnswerError,
							step5Items: res.data.data.step5Items,
							step6AnswerError: res.data.data.step6AnswerError,
							step6Items: res.data.data.step6Items,
						};
					});
				}
			},

			//下一步
			handleNextBtn() {
				if (this.$route.query.num === "1.1") {
					const obj = {
						stepTwo: true,
						stepThree: false,
						stepFour: false,
						stepFive: false,
						stepSix: false,
					};
					this.VISUAL_EXAMINATION({
						key: "contentObj",
						value: obj
					});
					this.VISUAL_EXAMINATION({
						key: "overIndex",
						value: 1
					});
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: this.treatmentList.id,
						questionId: '-209',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace("/treat/Catalog");
					});
				} else if (
					this.$route.query.num === "2.1" ||
					this.$route.query.num === "3.1" ||
					this.$route.query.num === "4.1" ||
					this.$route.query.num === "5.1"
				) {
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: this.$route.query.num,
						questionId: '-2013',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace("/treat/Catalog");
					});

				} else {
					let p = ''
					if (this.$route.query.num === "2") {
						p = '/treat/point'
					} else if (this.$route.query.num === "3") {
						p = '/treat/distinguish'
					} else if (this.$route.query.num === "4") {
						p = '/treat/clinical'
					} else if (this.$route.query.num === "5") {
						p = '/treat/final'
					} else if (this.$route.query.num === "6") {
						p = '/treat/affirm'
					}
					let newArr = [
						...this.detail,
						...this.detailsz2,
						...this.detail3,
						...this.detailstepPre3,
						...this.detail4,
						...this.detail5,
					];
					const parmes = {
						paperId: this.treatmentList.id,
						details: newArr,
					};
					submitExamCommitSingerAnswer({
						backendAnswers: JSON.stringify(parmes),
						paperId: p,
						questionId: '-5',
						answers: JSON.stringify({
							detail: this.detail,
							detailsz2: this.detailsz2,
							detail3: this.detail3,
							detailstepPre3: this.detailstepPre3,
							detail4: this.detail4,
							detail5: this.detail5,
							treatmentEcho: this.treatmentEcho
						}),
						extractDetailId: this.examDetailId,
					}).then((response) => {
						this.$router.replace(p);
					});

					// this.$router.go(-1)
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;
	}

	::-webkit-scrollbar {
		width: 19px;
		background-color: #ffffff;
		/*滚动条背景色*/
		border-radius: 9px;
		scrollbar-width: thin;
	}

	::-webkit-scrollbar-thumb {
		width: 13px;
		border-radius: 9px;
		background-color: #ab3b91;
		/*滚动条颜色*/
	}

	.medicalRecord-page {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;

		.record-content {
			width: 100%;
			padding: 0 50px 0px 50px;
			box-sizing: border-box;

			.content {
				width: 100%;
				height: 100%;
				background: rgba(255, 255, 255, 0.7);
				box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
				border: 2px solid #ffffff;
				border-radius: 60px;
				padding: 51px 27px 51px 62px;
				box-sizing: border-box;
				margin-bottom: 150px;
				position: relative;

				.glide {
					font-size: 0.7rem;
					font-weight: bold;
					color: #333333;
					position: absolute;
					bottom: 0;
					left: 4rem;

					i {
						color: #ab3b91;
					}
				}

				.content-height {
					height: 1038px;
					margin-bottom: 20px;

					.content-box {
						width: 100%;
						height: 100%;
						overflow-y: auto;
						padding-right: 34px;

						.container-scroll {
							width: 100%;
							// height: 100%;
							margin-top: 76px;

							.container-box {
								margin-top: 63px;

								.result {
									font-size: 26px;
									font-weight: bold;
									color: #e90000;
									margin-left: 54px;
									margin-bottom: 8px;
								}

								.content-title {
									margin-top: 12px;
									line-height: 45px;

									.tipLabel {
										font-size: 25px;
										font-weight: bold;
										color: #ab3b91;
										white-space: nowrap;
										margin-right: 15px;
									}

									.tipContent {
										font-size: 25px;
										font-weight: bold;
										color: #333333;
									}
								}
							}

							.content-titlejb {
								font-size: 25px;
								font-weight: 400;
								color: #333333;
								margin-top: 44px;
							}

							.title {
								display: flex;
								align-items: center;

								img {
									width: 42px;
									height: 37px;
								}

								p {
									font-size: 35px;
									font-family: HarmonyOS Sans SC;
									font-weight: bold;
									color: #333333;
									margin-left: 12px;
								}
							}
						}
					}
				}

				.topText {
					width: 100%;
					text-align: center;
					font-size: 30px;
					font-weight: bold;
					color: #ab3b91;
				}

				.detailed {
					width: 100%;
					margin-top: 94px;

					.detailedTop {
						display: flex;
						align-items: center;
						margin-bottom: 31px;

						img {
							width: 42px;
							margin-right: 12px;
						}

						.text {
							font-size: 35px;
							font-weight: bold;
							color: #333333;
						}
					}

					.classification {
						margin-top: 12px;
						line-height: 45px;

						.classification-blackText {
							flex: 1;
							font-size: 25px;
							font-weight: bold;
							color: #333333;
						}

						.classification-purpleText {
							font-size: 25px;
							font-weight: bold;
							color: #ab3b91;
							white-space: nowrap;
							margin-right: 15px;
						}
					}

					.purpleText {
						font-size: 25px;
						font-weight: bold;
						color: #ab3b91;
					}

					.blackText {
						font-size: 25px;
						font-weight: bold;
						color: #333333;
					}
				}
			}
		}

		.medicalRecordFooter {
			position: fixed;
			bottom: 0;
			width: 100%;
			height: 183px;
			border-radius: 60px 60px 0px 0px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-around;
			margin-top: 51px;

			.text {
				width: 274px;
				height: 85px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				border-radius: 42px;
				text-align: center;
				line-height: 85px;
				font-size: 35px;
				font-weight: 500;
				color: #ffffff;
			}
		}
	}

	.nextquestionactive {
		background: linear-gradient(138.51deg, rgba(0, 187, 177, 1) 0%, rgba(0, 80, 137, 1) 79.86%, rgba(171, 59, 127, 1) 100%);
		font-size: 32px;
		color: rgba(255, 255, 255, 1);
		display: flex;
		align-items: center;
		justify-content: center;
		width: 214px;
		height: 88px;
		border-radius: 100px;
	}

	.next1 {
		width: 28px;
		height: 24px;
		margin-right: 16px;
	}
</style>